var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconMinimizeVector = function SvgIconMinimizeVector(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 14v-2h-4.59L30 3.42 28.59 2 20 10.59V6h-2v8zM2 28.58 3.41 30 12 21.41V26h2v-8H6v2h4.59z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconMinimizeVector);
export { ForwardRef as ReactComponent };